import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import CourseContentManager from "./CourseContentManager";
// Chakra modals render in a portal on <body>, outside the .stande-classroom
// wrapper. The shell is themed with literal palette values, and carrying the
// wrapper class on ModalContent lets the children resolve the CSS variables.
import { PALETTES } from "./classroomColors";

const AddSegmentModal = ({ isOpen, onClose, onSuccess, courseGuid, isDark = true }) => {
  const p = isDark ? PALETTES.dark : PALETTES.light;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered scrollBehavior="inside">
      <ModalOverlay bg={p.overlay} backdropFilter="blur(2px)" />
      <ModalContent
        className="stande-classroom"
        data-theme={isDark ? "dark" : "light"}
        bg={p.surface}
        color={p.text}
        borderRadius="16px"
        border="1px solid"
        borderColor={p.border}
        boxShadow="0 24px 60px -20px rgba(0,0,0,0.5)"
        maxHeight="88vh"
        mx="16px"
      >
        <ModalHeader fontSize="18px" fontWeight="600" color={p.text} letterSpacing="-0.2px">
          Manage course content
        </ModalHeader>
        <ModalCloseButton borderRadius="full" color={p.textSub} _hover={{ bg: p.hover }} />
        <ModalBody pb="24px" overflowY="auto">
          <CourseContentManager onClose={onClose} onSuccess={onSuccess} courseGuid={courseGuid} isDark={isDark} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddSegmentModal;
